/**
 * ReservationTermSelect
 * ======================================
 */

const ELEMENT = '#js-ReservationTermSelect'
const INPUT = '#js-ReservationTermInput'

class ReservationTermSelect {
  constructor() {
    this.select = document.querySelector(ELEMENT)

    if(!this.select){
      return
    }

    this.select.addEventListener('change', this.change, false)
  }

  change(e) {
    const el = document.querySelector(ELEMENT)
    const option = el.options[el.selectedIndex]
    const max = option.getAttribute('data-max-persons')

    document.querySelector(INPUT).setAttribute('max', max)
  }
}

new ReservationTermSelect()
